export default {
  data() {
    return {
      mergedPages: ["mortgage-details", "property"]
    };
  },
  methods: {
    async navigateTo(element, duration = 500, container = "#app-data-container") {
      await this.$nextTick();
      await this.$nextTick();
      this.$scrollTo(element, duration, {
        container,
        offset: -50,
        force: true,
        cancelable: true
      });
    }
  }
};